import { render, staticRenderFns } from "./InjuryTypeUpdate.vue?vue&type=template&id=2fd39442&"
import script from "./InjuryTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./InjuryTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports